import React from "react";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { history } from "../../../../history";
import { BI_ROUTES } from "../../../../consts/routes";
import { StaticReportsBox } from "../../components/StaticReportsBox/StaticReportsBox";

export function PatientsStaticReports() {
  const { tBi } = useAppTranslation.BusinessInsights();

  const reports = [
    {
      key: 1,
      label: tBi("qualiphyPaidExamsReport.label"),
      isVisible: true,
      onClick: () => history.push(BI_ROUTES.qualiphyPaidExamsReport()),
    },
    {
      key: 2,
      label: tBi("noClinicPatientsReport.label"),
      isVisible: true,
      onClick: () => history.push(BI_ROUTES.noClinicPatientsReport()),
    },
  ];

  return <StaticReportsBox reports={reports} />;
}
